module.exports = __webpack_public_path__ + "static/img/code.6dba8c2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/code.jpg
// module id = d46q
// module chunks = 1